export * from './lib/format-date';
export * from './lib/format-relative';
export * from './lib/pacs';
// the string like MED-DEV-SOFTWARE-VERSION-TARGET gets replaced in Pipelines at deploy for staging and production
export const MedDevSoftwareVerion = "1.13"